// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import cstmTable from '../../../share/components/vue/PaginationTable';
import alert from '../../../share/alert';
import authority from '../../../share/util/authorityCheck';
import handler from '../../../share/util/apiResultValidator';
import vehicle from '../../../share/util/vehicle';
import util from '../../../share/util/utils';
import loading from '../../../share/components/vue/ProcessingIcon';
import table from '../../../store/modules/table';
import config from '../../../share/config';
import apiService from "../../../share/util/api/service";

const TABLE_COLUMN_NAME_MAP = [
  { mode: 'campaign', name: 'nameForDefaultTbl' }, { mode: 'update', name: 'nameForUpdateTbl' }, { mode: 'updateProgram', name: 'updateProgramTbl' }, { mode: 'updateChange', name: 'nameForUpdateChangeTbl' }, { mode: 'restore', name: 'nameForRestoreTbl' }
];

export default {
  data() {
    return {
      processing: false,
      vin: '',
      my: '',
      model: '',
      isPublished: true,
      isVisible: false,// 非公開リプロファイル一覧の表示権限
      isUpdate: true,
      pfcFileSerialNo: '',

      publishedTableItems: [],
      unpublishedTableItems: [],
      merchandiseCodeTable: [],
      publishedMerchandiseCodeList: [],
      unpublishedMerchandiseCodeList: [],
      updateProgramFlg: false,
      showModalSerialNo: false,
      cacheUnPublishedTableItems: [],
      cachePublishedTableItems: [],
      /** HTML 非バインド変数 */
      selectedUnit: {},
      isRestoreVersion: true,
      tabTitle: '',
      reprogramTableTypes: []
    };
  },

  props: {
    tableData: {
      type: Object,
      required: false,
      default: () => ({})
    },
  },

  components: {
    'cstm-table': cstmTable,
    'processing-view': loading,
  },

  watch: {
    tableData(tbl) {
      if (!tbl || !tbl.published) return;
      this.updateTargetUnitDisplayName(tbl.published || [], tbl.unpublished || []);
      this.computeVisible();
      this.computeTableTypes();
    },
    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
        if (this.displayReproTypeMode === "updateProgram") {
          // 商品選択画面
          this.filterUpdateProgramTable();
        } else if (this.displayReproTypeMode === "updateChange") {
          // 商品選択後の画面
          this.filterUpdateProgramTable();
          this.$emit('getPfcFile', this.selectMerchandiseInfo);
          this.filterMerchandiseUnitTable();
        } else {
          this.updateTargetUnitDisplayName(this.publishedTableItems, this.unpublishedTableItems);
        }
        this.updateTabTitle();
      }
    },
  },

  computed: {
    ...mapState({
      authGroup: state => state.userProperty.group,
      displayMode: state => state.cache.showPublished,
      displayReproTypeMode: state => state.cache.showDisplayVehicle,
      resources: state => state.masterResources.targetUnits,
      language: state => state.systems.language,
      viewMode: state => state.app.viewProcessMode,
      isTestMode: state => state.netAppConnector.isTestMode,
      netAppId: state => state.netAppConnector.pairingAppId,
      merchandiseInfo: state => state.cache.merchandiseInfo,
      updateProgramInfo: state => state.cache.updateProgramInfo,
      serialNumber: state => state.cache.serialNumber,
      selectMerchandiseInfo: state => state.cache.selectMerchandiseInfo,
      beforeTransitionTable: state => state.cache.beforeTransitionTable,
      // TS連携でシステム画面から戻った場合は初期化を実施する
      needInitializationProcess: state => state.app.directMove && state.app.directMove.direct_name === 'systemInformation'
    })
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('targetUnit', ['setTargetUnit']),
    ...mapActions('cache', ['cacheCcuReproInfo', "cacheSerialNumber", "cacheUpdateProgramInfo", "cacheMerchandiseInfo", "cacheSelectMerchandiseInfo", "cacheBeforeTransitionTable", "cacheSystemTable"]),

    // 任意のシステムが選択されたことを親に通知
    clickRow: function (selected) {
      if (this.updateProgramFlg === true) {
        // 商品一覧画面を表示しているとき
        if (selected.verificationType === "password" && this.serialNumber === null) {
          this.cacheCcuReproInfo({ systemName: null, newSwid: null, usbSwid: null, fileType: null });
          this.$emit('selectReproTableRow', selected);
          // パスワード管理の場合は商品一覧画面での照合は必要ないので、商品に紐づくユニット一覧をそのまま表示する
          this.showMerchandiseList();
          this.updateProgramFlg = false;
        } else {
          // シリアル番号入力ダイアログを表示する
          this.selectedCache = selected;
          this.showModalSerialNo = true;
        }
      } else {
        if (this.displayReproTypeMode === 'updateChange') {
          if (selected.reproExecutable.merchant === true) {
            this.$emit('changeTableTypes', 'update');
          } else if (selected.reproExecutable.restore === true) {
            this.$emit('changeTableTypes', 'restore');
          } else {
            this.$emit('changeTableTypes', 'normal');
          }
        }
        // CCUのキャッシュをクリア
        this.cacheCcuReproInfo({ systemName: null, newSwid: null, usbSwid: null, fileType: null });
        this.$emit('selectReproTableRow', selected);
      }
    },


    // 公開・非公開テーブルの切り替え
    switchTable: function () {
      this.isPublished = !this.isPublished;
      this.$emit('switchPublishmentMode', this.isPublished);
    },

    /**
     * 商品一覧画面から商品に紐づくユニット一覧を表示する
     */
    showMerchandiseList: function () {
      this.$emit('changeTableTypes', 'updateChange');
      this.filterMerchandiseUnitTable();
      this.updateTabTitle();
    },

    /**
     * 機能向上・復元リプロありのユニットをフィルタして画面に反映する
     */
    filterMerchandiseUnitTable: function () {
      const prefix = 'message.a_';
      const systemPublishList = [];
      const systemUnPublishList = [];

      const publishedList = this.merchandiseInfo.published || [];
      const unpublishedList = this.merchandiseInfo.unpublished || [];

      const filterReprogrammableUnit = ((merchandiseInfo) => {
        // 機能向上・復元のいずれかがリプロありのユニットのみ残す
        return merchandiseInfo.filter(unitInfo => unitInfo.updateReproResource.startsWith(prefix) || unitInfo.restoreReproResource.startsWith(prefix));
      });

      systemPublishList.push(filterReprogrammableUnit(publishedList));
      systemUnPublishList.push(filterReprogrammableUnit(unpublishedList));
      // フィルタしたユニット情報を画面に反映する。
      this.updateTargetUnitDisplayName(systemPublishList, systemUnPublishList);
    },

    /**
     * 商品一覧画面を表示する
     */
    filterUpdateProgramTable: async function () {
      this.cacheSerialNumber(null);
      this.merchandiseCodeTable = table.state.merchandiseTable;
      this.unpublishedTableItems = [];
      this.publishedTableItems = [];
      this.updateProgramList('published');
      this.updateProgramList('unPublished');
      this.computeVisibleForUpdateProgramList();
    },

    updateProgramList: async function (pubType) {
      if (pubType === 'published') {
        this.merchandiseCodeTable = table.state.merchandiseTable.pub;
      } else if (pubType === 'unPublished') {
        this.merchandiseCodeTable = table.state.merchandiseTable.unpub;
      }
      for (let lstCnt = 0; this.merchandiseCodeTable.length > lstCnt; lstCnt++) {
        for (let displayCnt = 0; this.merchandiseCodeTable[lstCnt].data.display_names.length > displayCnt; displayCnt++) {
          if (this.merchandiseCodeTable[lstCnt].data.display_names[displayCnt].language === this.language) {
            if (pubType === 'published') {
              this.publishedTableItems.push({
                updateProgramTbl: this.merchandiseCodeTable[lstCnt].data.display_names[displayCnt].name,
                merchandiseCode: this.merchandiseCodeTable[lstCnt].data.merchandise_code,
                verificationType: this.merchandiseCodeTable[lstCnt].data.verification_type,
                publishedType: pubType
              });
            } else {
              this.unpublishedTableItems.push({
                updateProgramTbl: this.merchandiseCodeTable[lstCnt].data.display_names[displayCnt].name,
                merchandiseCode: this.merchandiseCodeTable[lstCnt].data.merchandise_code,
                verificationType: this.merchandiseCodeTable[lstCnt].data.verification_type,
                publishedType: pubType
              });
            }
          }
        }
      }
      this.cacheUpdateProgramInfo({ publishedTableItems: this.publishedTableItems, unpublishedTableItems: this.unpublishedTableItems });
      return;
    },


    // 特約店専用メニューが押下されたとき、アップデートプログラムを表示する
    updateProgram: async function () {
      this.updateProgramFlg = true;
      await this.filterUpdateProgramTable();
      this.$emit('changeTableTypes', 'updateProgram');
      this.updateTabTitle();
      return;
    },

    // 特約店専用メニュー表示時の公開/非公開判定
    computeVisibleForUpdateProgramList: function () {

      // 公開/非公開ボタンの表示/非表示を判定する
      // 非公開リプロ実行可能なユーザか
      const auth = authority.hasUnpublishedPermission(this.authGroup);
      /**
       * 下記を満たす場合は「非公開ファイル一覧へ」ボタンを表示しない
       * 1. 非公開商品コード一覧の応答が空配列
       */
      const hasTarget = this.unpublishedTableItems.length !== 0;
      this.isVisible = auth && hasTarget;
      // 非公開ファイル一覧を表示する必要がないなら、「非公開ファイル一覧へ」ボタンを表示する必要もない
      if (!this.isVisible) {
        this.isPublished = true;
        this.$emit('switchPublishmentMode', this.isPublished);
      }
    },

    // シリアル番号が5桁目の入力時に自動で「-」を挿入する
    serialNoFormatter: function (inputValue, event) {
      if (event.type === "input" && inputValue.length === 5) {
        return inputValue + "-";
      }
      return inputValue;
    },

    //シリアル番号認証
    checkPfcFileSerialNo: async function () {
      this.showModalSerialNo = false;
      //入力値が空の場合は処理を終了
      if (!this.pfcFileSerialNo) {
        const messages = this.$t("message.message_repro_merchantability_serial_error");
        alert.showError(this, null, messages, () => {
          this.pfcFileSerialNo = '';
          this.showModalSerialNo = true;
        });
        return;
      }
      const merchandise_code = this.selectedCache.merchandiseCode;
      // dialogを閉じてくるくる表示
      this.processing = true;
      const isSerialNo = await apiService.postCall(
        config.REPRO,
        '/merchandise/' + merchandise_code + '/serialNumbers/confirm',
        {
          net_app_id: this.netAppId,
          serial_number: this.pfcFileSerialNo
        }
      );
      this.processing = false;
      handler.validate(
        handler.validateTypes.all,
        isSerialNo, this, null,
        () => {
          // 処理が成功したときのコールバック処理
          if (isSerialNo.data.is_confirmed === true) {
            // CCUのキャッシュをクリア
            this.cacheCcuReproInfo({ systemName: null, newSwid: null, usbSwid: null, fileType: null });
            this.cacheSerialNumber(this.pfcFileSerialNo);
            this.$emit('selectReproTableRow', this.selectedCache);
            this.$emit('serialNoDialog', this.pfcFileSerialNo);
            // シリアル番号の照合に成功したら、商品に紐づくユニット一覧を表示する
            this.showMerchandiseList();
            this.pfcFileSerialNo = '';
            this.updateProgramFlg = false;
          } else {
            // エラーを出して入力ダイアログに戻る
            const messages = this.$t("message.message_repro_merchantability_serial_error");
            alert.showError(this, null, messages, () => {
              this.pfcFileSerialNo = '';
              this.showModalSerialNo = true;
            });
          }
        },
        (result) => {
          // 処理が失敗したときのコールバック処理
          if (result.behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          }
        }
      );
    },

    // 非公開リプロの可否を判断
    computeVisible: function () {
      // サインインユーザーがシステム管理者・サービス管理者・SBRリプロ評価者か
      const auth = authority.hasUnpublishedPermission(this.authGroup);
      /**
       * 下記のいずれかを満たす場合は「非公開ファイル一覧へ」ボタンを表示しない
       * 1. 非公開ファイル一覧の応答が空配列
       * 2. 非公開ファイルがすべてリプロ不要
       */
      let hasTarget = false;
      if (this.tableData.unpublished) {
        const idx = this.tableData.unpublished.findIndex(el => {
          const l = [el.normalReproResource, el.updateReproResource, el.restoreReproResource];
          return el.reproExecutable || l.includes('message.common_hyphen');
        });
        hasTarget = idx !== -1;
      }
      this.isVisible = auth && hasTarget;
      // 非公開ファイル一覧を表示する必要がないなら、「非公開ファイル一覧へ」ボタンを表示する必要もない
      if (!this.isVisible) {
        this.isPublished = true;
        this.$emit('switchPublishmentMode', this.isPublished);
      }
    },

    computeTableTypes: function () {
      this.reprogramTableTypes = [];
      if (this.tableData.published) {
        for (const ecu of this.tableData.published) {
          const isUpdateRpr = ecu.updateReproResource && ecu.updateReproResource.startsWith('message.a_');
          const isRestoreRpr = ecu.restoreReproResource && ecu.restoreReproResource.startsWith('message.a_');
          if (isUpdateRpr && !this.reprogramTableTypes.includes('update')) this.reprogramTableTypes.push('update');
          if (isRestoreRpr && !this.reprogramTableTypes.includes('restore')) this.reprogramTableTypes.push('restore');
        }
      }
      if (!this.isVisible) return;
      if (this.tableData.unpublished) {
        for (const ecu of this.tableData.unpublished) {
          const isUpdateRpr = ecu.updateReproResource && ecu.updateReproResource.startsWith('message.a_');
          const isRestoreRpr = ecu.restoreReproResource && ecu.restoreReproResource.startsWith('message.a_');
          if (isUpdateRpr && !this.reprogramTableTypes.includes('update')) this.reprogramTableTypes.push('update');
          if (isRestoreRpr && !this.reprogramTableTypes.includes('restore')) this.reprogramTableTypes.push('restore');
        }
      }
    },

    // テーブルのツールチップ表示
    onMouseHover: function (data) {
      if (data && data.popup) {
        // 取得した値が「-」の場合はエラー文言を表示する。
        if ('message.common_hyphen' === data.rowData.value) {
          const msgMap = [
            { name: 'normalReproResource', msgId: 'message.label_id_not_read' },
            { name: 'updateResource', msgId: 'message.label_id_not_read' },
            { name: 'restoreResource', msgId: 'message.label_id_not_read' },
            { name: 'installationResource', msgId: 'message.label_unit_not_read' },
            { name: 'communicableResource', msgId: 'message.label_connection_not_read' },
          ];
          const filtered = msgMap.filter(m => m.name === data.rowData.columnName);
          data.popup.name = this.$t(filtered.length > 0 ? filtered[0].msgId : '');
        }
      }
    },

    // Update target unit display name
    updateTargetUnitDisplayName: function (publishedList, unpublishedList) {
      const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      const publishedTableItemsTemp = [...publishedList];
      const unpublishedTableItemsTemp = [...unpublishedList];
      const name = TABLE_COLUMN_NAME_MAP.filter(e => e.mode === this.displayReproTypeMode)[0].name;
      publishedTableItemsTemp.forEach(element => element[name] = targetUnitDisplayData[`${element.id}`] || '');
      unpublishedTableItemsTemp.forEach(element => element[name] = targetUnitDisplayData[`${element.id}`] || '');
      this.publishedTableItems = publishedTableItemsTemp;
      this.unpublishedTableItems = unpublishedTableItemsTemp;
    },

    // 機能向上・以前のバージョンに復元画面から市場措置/その他画面へ戻る
    back: function () {
      if (this.updateProgramFlg === true) {
        this.updateProgramFlg = false;


        this.cacheSelectMerchandiseInfo("");
        this.cacheMerchandiseInfo({ published: null, unpublished: null });
        this.cacheSystemTable(this.beforeTransitionTable);

        this.updateTabTitle();
        this.tableData.published = this.beforeTransitionTable.published;
        this.tableData.unpublished = this.beforeTransitionTable.unpublished;

        // 商品一覧画面から通常リプロの一覧に戻る
        this.$emit('changeTableTypes', 'campaign');
        this.updateTargetUnitDisplayName(this.tableData.published || [], this.tableData.unpublished || []);
        this.computeVisible();
        return;
      }
      this.$emit('changeTableTypes', 'updateProgram');
      this.updateTabTitle();
      this.cacheSerialNumber(null);
      this.updateProgram();
      this.updateProgramFlg = true;
    },

    updateTabTitle: function () {
      // タイトルタブの切替
      if (this.displayReproTypeMode === "updateChange") {
        this.tabTitle = this.$t('message.header_vehicle_system_update_tree_Modules');
        return;
      }
      if (this.displayReproTypeMode === "update") {
        this.tabTitle = this.$t('message.header_vehicle_system_update_tree_Modules');
        return;
      }
      if (this.displayReproTypeMode === "restore") {
        this.tabTitle = this.$t('message.header_vehicle_system_update_tree_Modules');
        return;
      }
      if (this.displayReproTypeMode === "updateProgram") {
        this.tabTitle = this.$t('message.header_vehicle_system_updateProgram_tree_modules');
        return;
      }
      else {
        this.tabTitle = this.$t('message.header_vehicle_system_tree_Modules');
        return;
      }
    },

    setupTableColumn: function () {
      const defaultSystemTableColumns = [
        { name: 'nameForDefaultTbl', label: 'message.header_vehicle_system_table_unit' },
        { name: 'targetId', label: 'message.header_vehicle_system_ids' },
        { name: 'normalReproResource', label: 'message.header_vehicle_system_table_has_repro_data', useResource: true },
        { name: 'installationResource', label: 'message.header_vehicle_system_table_installation', useResource: true },
        { name: 'communicableResource', label: 'message.header_vehicle_system_table_communication', useResource: true }
      ];
      const updateSystemTableColumns = [
        { name: 'nameForUpdateTbl', label: 'message.header_vehicle_system_table_unit' },
        { name: 'targetId', label: 'message.header_vehicle_system_ids' },
        { name: 'updateReproResource', label: 'message.header_vehicle_system_table_has_update_reprogrammable', useResource: true },
        { name: 'installationResource', label: 'message.header_vehicle_system_table_installation', useResource: true },
        { name: 'communicableResource', label: 'message.header_vehicle_system_table_communication', useResource: true }
      ];
      const updateProgramTableColumns = [
        { name: 'updateProgramTbl', label: 'message.header_vehicle_update_program_table' }
      ];
      const updateChangeSystemTableColumns = [
        { name: 'nameForUpdateChangeTbl', label: 'message.header_vehicle_system_table_unit' },
        { name: 'targetId', label: 'message.header_vehicle_system_ids' },
        { name: 'updateReproResource', label: 'message.header_vehicle_system_table_has_update_reprogrammable', useResource: true },
        { name: 'restoreReproResource', label: 'message.header_vehicle_system_table_has_restore_version_reprogrammable', useResource: true },
        { name: 'installationResource', label: 'message.header_vehicle_system_table_installation', useResource: true },
        { name: 'communicableResource', label: 'message.header_vehicle_system_table_communication', useResource: true }
      ];
      const restoreSystemTableColumns = [
        { name: 'nameForRestoreTbl', label: 'message.header_vehicle_system_table_unit' },
        { name: 'targetId', label: 'message.header_vehicle_system_ids' },
        { name: 'restoreReproResource', label: 'message.header_vehicle_system_table_has_restore_version_reprogrammable', useResource: true },
        { name: 'installationResource', label: 'message.header_vehicle_system_table_installation', useResource: true },
        { name: 'communicableResource', label: 'message.header_vehicle_system_table_communication', useResource: true }
      ];
      return this.displayReproTypeMode === 'update' ? updateSystemTableColumns : this.displayReproTypeMode === 'updateChange' ? updateChangeSystemTableColumns : this.displayReproTypeMode === 'updateProgram' ? updateProgramTableColumns : this.displayReproTypeMode === 'restore' ? restoreSystemTableColumns : defaultSystemTableColumns;
    }
  },

  created() {
    // noop
  },

  mounted() {
    this.$emit('setVehicleTabsAvailable', true);
    // 選択中の対象ユニットを初期化
    this.setTargetUnit(null);
    // CCUのリプロ情報を初期化
    this.cacheCcuReproInfo({ systemName: null, newSwid: null, usbSwid: null, fileType: null });
    // 公開・非公開どちらのファイル一覧が表示中なのかを初期化
    this.isPublished = this.displayMode;
    this.computeVisible();
    this.computeTableTypes();

    // Menu画面以外の画面から遷移した場合はキャッシュ情報を使用する。 例外としてTS連携でシステム画面から戻った場合は初期化を実施する
    if (util.getPreviousDisplayName(this.$route) !== 'menu' && !this.needInitializationProcess) {
      //システムの詳細画面から遷移した際は選択した商品コードに応じた商品の一覧を表示する
      if (["update", "restore"].includes(this.displayReproTypeMode) && util.getPreviousDisplayName(this.$route) === 'result') {
        this.cacheBeforeTransitionTable({ published: this.tableData.published, unpublished: this.tableData.unpublished });
        this.$emit('getPfcFile', this.selectMerchandiseInfo);
        this.filterMerchandiseUnitTable();
        this.$emit('changeTableTypes', 'updateChange');
        this.updateTabTitle();
        this.$emit('changeTableTypes', this.displayReproTypeMode);
      } else if (["update", "restore"].includes(this.displayReproTypeMode)) {
        this.$emit('changeTableTypes', 'updateChange');
        this.$emit('getPfcFile', this.selectMerchandiseInfo);
        this.filterMerchandiseUnitTable();
        this.updateTabTitle();
        this.$emit('changeTableTypes', this.displayReproTypeMode);
      } else {
        // 品質改善リプロの場合
        const isAfterRepro = ['result', 'systemFileTable'].includes(util.getPreviousDisplayName(this.$route));
        // リプロ後の画面から遷移してきた場合は、リプロ後に取得したpublished/unPublishedの結果でテーブル更新する
        // 商品選択後の画面から遷移してきた場合は、キャッシュに保存したpublished/unPublishedの結果でテーブルを更新する
        const targetTableData = isAfterRepro ? this.tableData : this.beforeTransitionTable;
        this.updateTargetUnitDisplayName(targetTableData.published || [], targetTableData.unpublished || []);
        this.cacheBeforeTransitionTable({ published: targetTableData.published, unpublished: targetTableData.unpublished });
        this.$emit('changeTableTypes', this.displayReproTypeMode);
      }
    } else {
      // Menu画面からの画面表示
      this.cacheSelectMerchandiseInfo("");
      this.cacheMerchandiseInfo({ published: null, unpublished: null });
      this.$emit('changeTableTypes', 'campaign');
      this.updateTargetUnitDisplayName(this.tableData.published || [], this.tableData.unpublished || []);
      this.cacheBeforeTransitionTable({ published: this.tableData.published, unpublished: this.tableData.unpublished });
    }
    // タブ名の設定
    this.updateTabTitle();
    // 前回指定された画面名をクリア
    // ※パラメータに画面名が設定されていない場合、前回情報を保持し続けてしまうため
    if (util.getPreviousDisplayName(this.$route) !== 'execute') {
      this.$route.params.previousDisplayName = '';
    }
  }
};